import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
const names = ['Laura Méndez', 'Carlos Ruiz', 'Alejandra Vega', 'Martín López', 'Sofía Peralta', 'Diego Fernández', 'Natalia Romero', 'Federico Aguirre', 'Claudia Benítez', 'Pablo Herrera', 'Luciana Morales', 'Gustavo Ríos', 'Andrea Suárez', 'Hernán Castro', 'Daniela Ortiz'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 44) + 2; // 2 to 45 mins
      setCurrentData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
      // Then set interval for subsequent popups (random between 8-12s + 4s display time)
      const intervalId = setInterval(() => {
        showPopup();
      }, Math.random() * 4000 + 12000); // 12s to 16s total cycle
      return () => clearInterval(intervalId);
    }, 3000);
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-122">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-lg shadow-xl border border-slate-100 p-4 max-w-sm flex items-start gap-3" data-id="element-123">
          <div className="bg-[#1a365d]/10 p-2 rounded-full text-[#1a365d] shrink-0 mt-0.5" data-id="element-124">
            <ShoppingCart size={18} data-id="element-125" />
          </div>
          <div data-id="element-126">
            <p className="text-sm font-medium text-slate-800" data-id="element-127">
              <span className="font-bold" data-id="element-128">{currentData.name}</span> de{' '}
              {currentData.city} compró SIC 360
            </p>
            <p className="text-xs text-slate-500 mt-1" data-id="element-129">
              hace {currentData.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}